import React, { Fragment } from 'react';
import moment from 'moment';
import { Card, createStyles, Theme, withStyles } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import screeningStyles from './screeningReport.module.css';
import ScreeningReport from '../../models/ScreeningReport';
import ScreeningReportItem from '../../models/screeningReportItem';

interface ScreeningReportProps {
  classes: any;
  data: ScreeningReport;
};

const styles = (theme: Theme) =>
  createStyles({
   childTh: {
    display: 'table-row-group',
    boxShadow: 'none'
  }
});


function screeningReportData(props: ScreeningReportProps) {
  const { classes } = props;
  const exportMeta = props.data.export_metadata || {} as ScreeningReport['export_metadata'];
  const bookedFlight = exportMeta.firstFlightNumber
    ? `${exportMeta.firstFlightNumber}/${exportMeta.firstFlightDate ? moment(exportMeta.firstFlightDate).format('MMM DD') : ''}`
    : '-';

  return (

    <Fragment>
      
      <TableRow className={ screeningStyles.parentTable }>
        <TableCell component="td" scope="row" className={ screeningStyles.columnData }>
          { props.data.awb }
        </TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.pieces }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.weight + ' K' }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.org }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.dst }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ bookedFlight }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.forwarder_name }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ exportMeta.shipperProfile || '-' }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ exportMeta.ccsf ? 'Yes' : 'No' }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.pickup_date ? moment(props.data.pickup_date).format('DD MMM YY') + ' ' + (props.data.pickup_time || '') : '-' }</TableCell>
        <TableCell className={ screeningStyles.columnData }>{ props.data.csd }</TableCell>
      </TableRow>
      <TableRow className={ screeningStyles.insideTableRow }>
        <TableCell className={ screeningStyles.insideTable } colSpan={11} >
          <Card>
            <Table aria-label="purchases" className={ screeningStyles.tableStyle }>
              <TableHead className={ screeningStyles.childTh }>
                <TableRow>
                  <TableCell style={{width: '3%'}}>Pcs</TableCell>
                  <TableCell style={{width: '5%'}}>Scr Weight</TableCell>
                  <TableCell>Measure Applied</TableCell>
                  <TableCell style={{width: '17%'}}>Details</TableCell>
                  <TableCell style={{width: '10%'}}>For Flight</TableCell>
                  <TableCell>Rmks</TableCell>
                  <TableCell style={{width: '8%'}}>Screener</TableCell>
                  <TableCell>Date / Time</TableCell>
                  <TableCell>Alarm</TableCell>
                  <TableCell  style={{width: '10%'}}>Resolution</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={ screeningStyles.childBody }>
                {(props.data.screening || []).map((item: ScreeningReportItem) => {
                  return (
                    <TableRow key={ item.id }>
                      <TableCell className={ screeningStyles.piecesColumn }>
                        { item.screened_pieces }
                      </TableCell>
                      <TableCell>{ item.actual_weight }</TableCell>
                      <TableCell>{ item.measure_applied }</TableCell>
                      <TableCell>{ item.screening_details }</TableCell>
                      <TableCell>{ item.flight }</TableCell>
                      <TableCell>{ item.details }</TableCell>
                      <TableCell className={ screeningStyles.screenedColumn }>{ item.screened_by }</TableCell>
                      <TableCell className={ screeningStyles.dateColumn }>{ item.screening_date ? moment(item.screening_date).format('DD MMM YY') : '-' }{ item.screening_time ? '/' + moment(item.screening_time, 'hh:mm ss').format('HH:mm') : '' }
                      </TableCell>
                      <TableCell>{ item.alarm ? 'Yes': 'No' }</TableCell>
                      <TableCell>{ item.alarm ? item.alarm_resolution : '-' }</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Card>
        </TableCell>
      </TableRow>
      <TableRow className={ screeningStyles.BlankRow }></TableRow>

    </Fragment>

  );
}

export default  withStyles(styles)(screeningReportData);
